import ApiService from "@/core/services/api.service";
// import { deepCopy } from "@/util/index.js";
// let Base64 = require('js-base64').Base64;
// action types
export const ADDTABLE = "addTable";
export const ADDFORM = "addForm";
export const DELETEtABLE = "deleteTable";
export const GETROLES = "getRoles";
export const USERS = "users";
export const JURI = "jurisdiction";
export const ADDJURIMENU = 'addJurisdictionMenu'
//mutations types
export const SETTABLE = "setTable";


const state = {
    tablesData: []
};


const actions = {
    // [CHANGE_MENUS]({ commit }) {
    //   commit(SET_CHANGE_MENUS, MENU);
    //   return MENU;
    // },
    [ADDJURIMENU]({ commit }, o) {
        console.log(commit)
        return ApiService.get(`/api-user/menus/${o}/menus`)
    },
    [JURI]({ commit }, o) {
        console.log(commit)
        return ApiService.post(`/api-user/menus/granted`, o, { type: 'json' })
    },
    [USERS]({ commit }, o) {
        console.log(commit)
        return ApiService.put(`/api-user/users`, o, { type: 'json' })
    },
    [GETROLES]() {
        return ApiService.get(`/api-uaa/clients/all`);
    },
    [DELETEtABLE]({ commit }, id) {
        console.log(commit)
        return ApiService.delete(`/api-user/roles/${id}`);
    },
    [ADDFORM]({ commit }, o) {
        console.log(commit)
        return ApiService.post(`/api-user/roles/saveOrUpdate`, o, { type: 'json' })
    },
    [ADDTABLE]({ commit }, { page, limit, clientId = '', name = '' }) {
        console.log(commit)
        return ApiService.get(`/api-user/roles?clientId=${clientId}&page=${page}&limit=${limit}&name=${name}`)
    },

};
const mutations = {
    [SETTABLE](state, data) {
        state.tablesData = data;
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
